export default __webpack_public_path__ + "static/media/bra.b5aee8b0.svg";